import React, {useState} from "react";
import { NavLink } from 'react-router-dom';
import Icon from "./Element/Icon";
import imageUrl from  '../assets/logo.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';


export const Examens = () => {
 
  const [openPanel, setOpenPanel] = useState(null);
  const togglePanel = (panelId) => {
    setOpenPanel(openPanel === panelId ? null : panelId);
};
  
   return(
      <>
         <header className="App">
    
    
    <nav className="navbar-nav navbar navbar-expand-lg navbar-light bg-light ">   
  
     
       
       <NavLink className="navbar-brand" href="/">
         <img
           className="logo-ifc"
           src={imageUrl}
           alt="logo ifc"
          
           width='60px'
         />
       </NavLink >
       
     
       <ul className="nav navbar-nav">
         <li className="">
           <NavLink to="/accueil">Accueil</NavLink>
         </li>
         <li className="">
           <NavLink to="/Examen">Faqs</NavLink>
         </li>
         <li className="">
           <NavLink to="/Contact">Contact</NavLink>
         </li>
     
         <li className="">
           <NavLink to="/"></NavLink>
         </li>
         <li className="">
           <NavLink to="/espCandidat">EspaceCandidat</NavLink>
         </li>
       </ul>
     
   
 </nav>
 </header>
      <section className="section normalhead">
   <div class="container">
   <div class="row">
   <div class="col-md-12 col-sm-12 text-center">
   <h2>Foire aux questions</h2>
   <p className="lead">Pour répondre à toutes vos questions, veuillez lire les questions fréquemment posées.</p>
   
   </div>
   
   </div>
   
   </div>
   <div className="container" mt-5>
  <div className="row">
    <div className="col-md-12 mb30">
      <div className="faqs-template">
        <div className="panel-group" id="accordion">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">
                <a  onClick={() => togglePanel(1)} style={{ cursor: 'pointer' }} data-parent="#accordion" href="#collapse_1">1. Comment s'inscrire?
                <FontAwesomeIcon icon={faAngleDown} className={`float-right ${openPanel === 1 ? 'rotate' : ''}`} />
                </a>
              </h4>
            </div>
            <div className={`panel-collapse collapse ${openPanel === 1 ? 'show' : ''}`}>

              <div className="panel-body">
                <p>L'IFC, sur les sites de Douala et Yaoundé, vous propose différents tests et examens en fonction de votre projet qu'il soit personnel, académique ou professionnel.</p>
                <p>TCF (Test de Connaissance du Français) et TEF (Test d'Evaluation de Français) sont des tests qui indiquent le niveau de maîtrise de la langue française dans le cadre des procédures d'immigration au Canada ou dans tout autre pays francophone. Les attestations délivrées sont valables 2 ans.</p>
                <p>Le TCF et le TEF Canada pour l'immigration au Canada fédéral;</p>
                <p>le TCF Québec et le TEFAQ pour l'immigration pour la province du Québec 'exclusivement);</p>
                <p>le TCF tout public et le TEF Complet pour les mobilités académiques;</p>
                <p>le TCF et le TEF IRN pour la naturalisation (France).</p>
                <p><strong>NB :</strong> En cas de <strong>handicap visuel</strong>, <strong>auditif </strong>ou <strong>moteur </strong>vous empêchant de passer l'examen dans les mêmes conditions que tout le monde, <strong>ne vous inscrivez surtout pas !</strong> Adressez-nous une demande d'inscription avec le justificatif médical signé d'un spécialiste inscrit à l'Ordre des médecin, indiquant<strong> la nature</strong> et<strong> l'intensité du handicap</strong>, ainsi que les <strong>aménagements nécessaires</strong>. Cette demande sera transférée au certificateur pour validation préalable à votre inscription éventuelle</p>
              </div>
            </div>
          </div>
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">
                <a  onClick={() => togglePanel(2)} style={{ cursor: 'pointer' }} data-parent="#accordion" href="#collapse_6">2. Comment remplir mon formulaire candidat?
                <FontAwesomeIcon icon={faAngleDown} className={`float-right ${openPanel === 2 ? 'rotate' : ''}`} />
                </a>
              </h4>
            </div>
            <div className={`panel-collapse collapse ${openPanel === 2 ? 'show' : ''}`}>
              <div className="panel-body">
                <p>1- Afin de faciliter le traitement de votre candidature et surtout éviter le rejet de votre formulaire candidat, merci de respecter le format suivant dans la saisie de vos nom(s) et prénom(s):</p>
                <p>Nom: tous les caractères en majuscules. Exemple KOFFI ASUE</p>
                <p>Prénom: La permière lettre de chaque prénom en majuscule et les lettres suivantes en minuscule. Exemple <u>A</u>nnie <u>M</u>arion</p>
                <p>Attention au format des fichiers (photo et pièce d'identité) à téléverser. Le format exigé est "jpeg".</p>
              </div>
            </div>
          </div>
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">
                <a onClick={() => togglePanel(3)} style={{ cursor: 'pointer' }} data-parent="#accordion" href="#collapse_2">3.Comment savoir si je suis pretes pour debuter mon inscription ?
                <FontAwesomeIcon icon={faAngleDown} className={`float-right ${openPanel === 3 ? 'rotate' : ''}`} />
                </a>
              </h4>
            </div>
            <div className={`panel-collapse collapse ${openPanel === 3 ? 'show' : ''}`}>
              <div className="panel-body">
                <p>Etre pret pour la prinscription signifie etre rapide et tout dependra du temps et du score que vous aurez fait apres votre <br/>simulation
                et aussi de votre mention </p>
                <p>NB : Voici le lien du site de l'Ifc (DOUALA): "https://douala.ifc-tests-examens.com/examens-session/17-test-d-valuation-de-franais-pour-le-canada".
                  <br/>(YAOUNDE): "https://yaounde.ifc-tests-examens.com/examens-session/10-test-de-connaissance-du-franais-pour-le-canada"
                </p>
              </div>
            </div>
          </div>
          <div className="panel panel-default">
            <div className="panel-heading">
              <h4 className="panel-title">
                <a onClick={() => togglePanel(4)} style={{ cursor: 'pointer' }} data-parent="#accordion" href="#collapse_2">4. Quels sont les délais de publication des résultats ?
                <FontAwesomeIcon icon={faAngleDown} className={`float-right ${openPanel === 4 ? 'rotate' : ''}`} />
                </a>
              </h4>
            </div>
            <div className={`panel-collapse collapse ${openPanel === 4 ? 'show' : ''}`}>
              <div className="panel-body">
              <p>Les r&eacute;sultats des tests TCF et TEF sur ordinateur sont disponibles apr&egrave;s 10 jours ouvrables et ceux du DELF-DALF 
   apr&egrave;s 2 semaines.</p>
   <p>NB :<br />
   <strong>a-</strong> Pour le cas sp&eacute;cifique du DELF-DALF, il faut attendre 8 semaines au minimum, apr&egrave;s la publication des r&eacute;sultats, pour obtenir le <strong>dipl&ocirc;me DELF-DALF</strong>
    original qui sera exp&eacute;di&eacute; au Cameroun par le biais de la valise diplomatique.</p>

<p><strong>b-</strong> Pour les TCF 
et TEF, l&#39;attestation d&eacute;mat&eacute;rialis&eacute;e est 
envoy&eacute;e &agrave;&nbsp; votre adresse mail personnelle soit
 par les soins du centre d&#39;examen (TCF) ou du certificateur FDA (TEF).</p>
 <p><strong>c-</strong> Le retrait du dipl&ocirc;me original se fait par le candidat sur pr&eacute;sentation d&#39;une pi&egrave;ce d&#39;identit&eacute; ou d&#39;un passeport valide. Si vous souhaitez qu&#39;un tiers s&#39;en charge, il faudra lui donner une procuration l&eacute;galis&eacute;e que
  le centre d&#39;examen va retenir.</p>
  </div>
            </div>
            </div>
        </div>
        </div>
        </div>
        </div>
  
   <div
               className="section-button clearfix text-center">
                   <p>cliquez sur ce bouton pour commencer votre simulation</p>
                           <a href="/faq" className="button-container">Je m'inscris</a>
            </div>
   </div>
      </section>
      <div>
    <a href="/" > <Icon name="precedent" /></a>
    <a href="/Examen" ><Icon name="question" /></a>
    <a href="/faq" > <Icon name="register" /></a>
    <a href="/accueil" > <Icon name="home" /></a>
    </div>
      <footer className="footer secondary-footer" style={{ backgroundColor: '#928490 ' }}>
      <div className="container">
         <div class="row">
         <div
         className="col-md-12 col-sm-12 col-xs-12"
         style={{ textAlign: "center" }}
       >
               <p>Objectif Canada</p>
            </div>
            
         </div>
       
      </div>
      
      
   </footer>
      </>
   )
   }